import * as React from "react";
import { Alert } from "@traceair/tds";
import { stylesheet } from "typestyle";

const css = stylesheet({
  error: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  alert: {
    width: 244,
  },
});

interface IProps {
  message: string;
}

export const PageError: React.FC<IProps> = ({ message }) => {
  return (
    <div className={css.error}>
      <Alert
        className={css.alert}
        type="warning"
        title="Error occured in the application."
        description={message}
      />
    </div>
  );
};
